<script setup>
  import MapLayout from '@/components/MapLayout.vue';
  import ToastHost from '@/components/base/ToastHost.vue';
</script>

<template>
  <MapLayout />
  <ToastHost />
</template>
